import { httpClient } from '../network/httpclient/HttpClientFactory';
import reAuthHeader from './ReHeader';

const login = param => httpClient.post(`/admin/login`, param).then(res => res.data);
const logout = () => httpClient.get(`/admin/logout`).then(res => res.data);

const refreshToken = param =>
    httpClient.post(`/admin/refreshToken`, param, { headers: reAuthHeader() }).then(res => res.data);

export default {
    login,
    logout,
    refreshToken
};
